import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'
import { AutoOfferRate } from './types'
import autoOfferRateTypes from './action-types'

export default generateEntityCrudReducer<AutoOfferRate>({
  name: 'autoOfferRate',
  actions: autoOfferRateTypes,
  extraActions: { DOWNLOAD_CSV: autoOfferRateTypes.AUTO_OFFER_RATES_CSV_DOWNLOAD_BEGIN },
})
